import React, { PureComponent } from 'react';
import { Type } from '@spotify-internal/encore-creator-web';
import cn from 'classnames';
import { EmptyPlaceholder } from '../EmptyPlaceholder';
import styles from './index.module.css';
import { PreviewPanePodcast } from '../../../../types';

// this could probably be shared/pulled from the css module
const VERTICAL_BREAKPOINT = 750;

interface Props {
  rssFeed: PreviewPanePodcast | null;
  className?: string;
  showCelebration?: boolean;
  panelOffset: number;
}

interface State {
  windowHeight: number;
}

export class BasicInfo extends PureComponent<Props, State> {
  state = {
    windowHeight: window.innerHeight,
  };

  componentDidMount() {
    this.resize();
    window.addEventListener('resize', this.resize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize, false);
  }

  resize = () => this.setState({ windowHeight: window.innerHeight });

  render() {
    const { rssFeed, showCelebration, className, panelOffset } = this.props;
    const image = rssFeed && rssFeed.image;
    const { windowHeight } = this.state;

    const isSmallHeight = windowHeight < VERTICAL_BREAKPOINT;
    const leftTranslate = panelOffset / 2;
    /* istanbul ignore next */
    const imageScaling = isSmallHeight ? 1 : 1.5;
    /* istanbul ignore next */
    const imageOffset = isSmallHeight
      ? `${leftTranslate}px, ${-60}px`
      : `${leftTranslate}px, ${0}px`;

    return (
      <div className={className}>
        <div
          className={styles.album_art}
          style={{
            backgroundImage: image ? `url('${image}')` : '',
            backgroundColor: image ? 'transparent' : '',
            transform: showCelebration ? `translate(${imageOffset}) scale(${imageScaling})` : '',
          }}
        />
        {!showCelebration && (
          <div>
            <div className={styles.title_container}>
              {rssFeed && rssFeed.title ? (
                <Type as="h1" className={styles.title} variant={Type.heading3}>
                  {rssFeed.title}
                </Type>
              ) : (
                <TextPlaceholder />
              )}
            </div>
            <div className={styles.author_name_container}>
              {rssFeed && rssFeed.author ? (
                <Type as="p" className={styles.author_name} variant={Type.cta3}>
                  {`By ${rssFeed.author}`}
                </Type>
              ) : (
                <TextPlaceholder />
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

function TextPlaceholder() {
  return (
    <div className={styles.placeholder_wrapper}>
      <Type as="h1" className={cn(styles.title, styles.placeholder_text)} variant={Type.heading3}>
        &nbsp;
      </Type>
      <div className={styles.placeholder_bar_container}>
        <EmptyPlaceholder className={styles.placeholder_bar} />
      </div>
    </div>
  );
}
